module.exports = __webpack_public_path__ + "img/dea-formazione-ico-arte.8f3be20a.svg";